export class Constants {
  static OTP_CODE_LENGTH: number = 5;
  static RESEND_OTP_TIMER_IN_SECONDS: number = 30;
  static RECCO_VIDEO_DURATION_IN_SECONDS: number = 600;
  static GIVE_RECCO_CHARACTER_LIMIT: number = 500;
  static TYPING_DEBOUNCE_DELAY: number = 300;
  static RECCO_APP_STORE_URL: string = 'https://app.recco.ai/cE2crMtqoQb';
}
